import { render, staticRenderFns } from "./FileBox.vue?vue&type=template&id=bbe8dce6&scoped=true&"
import script from "./FileBox.vue?vue&type=script&lang=js&"
export * from "./FileBox.vue?vue&type=script&lang=js&"
import style0 from "./FileBox.vue?vue&type=style&index=0&id=bbe8dce6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbe8dce6",
  null
  
)

export default component.exports